// import React, { useEffect, useState, useMemo } from "react";
// import classes from "./Category.module.css";
// import BreadCrumb from "../../components/Breadcrumb";
// import PaginationComp from "../../components/PaginationComp";
// import API from "../../utils/api";
// import { filterVisibleCategories } from "../../utils/categoryFilters";
// import { FaBoxOpen } from "react-icons/fa";
// import { Helmet } from "react-helmet";

// const CATEGORIES_PER_PAGE = 10;

// export default function Category() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       setLoading(true);
//       const res = await API.post("/categories.php", { action: "fetch" });
//       const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
//       const visible = filterVisibleCategories(data);
//       const nonEmpty = visible.filter((cat) => Number(cat.count) > 0);
//       setCategories(nonEmpty);
//     } catch (err) {
//       console.error("Failed to fetch categories:", err);
//       setCategories([]);
//     } finally {
//       setLoading(false);
//       setCurrentPage(1);
//     }
//   };

//   const paginatedCategories = useMemo(() => {
//     const start = (currentPage - 1) * CATEGORIES_PER_PAGE;
//     return categories.slice(start, start + CATEGORIES_PER_PAGE);
//   }, [categories, currentPage]);

//   return (
//     <>
//       <Helmet>
//         <title>
//           Product Categories - TechMatter UK | Servers, PCs & Networking
//         </title>
//         <meta
//           name="description"
//           content="Browse all product categories at TechMatter UK. Find high-quality servers, PCs, networking equipment, and IT hardware with detailed product listings."
//         />
//         <link rel="canonical" href="https://techmatter.co.uk/category" />
//       </Helmet>
//       <BreadCrumb currentPage="Category" />

//       <div className={classes.categoryWrapper}>
//         {loading ? (
//           <div className={classes.loader}>Loading categories...</div>
//         ) : categories.length === 0 ? (
//           <div className={classes.noCategories}>No categories found.</div>
//         ) : (
//           <>
//             <div className={classes.categoryGrid}>
//               {paginatedCategories.map((cat) => (
//                 <div key={cat.id} className={classes.categoryCard}>
//                   <div className={classes.iconWrapper}>
//                     <FaBoxOpen size={40} color="var(--primary-color)" />
//                   </div>
//                   <h3 className={classes.categoryName}>{cat.categoryName}</h3>
//                   <p className={classes.categoryCount}>{cat.count} products</p>
//                 </div>
//               ))}
//             </div>

//             <PaginationComp
//               total={categories.length}
//               perPage={CATEGORIES_PER_PAGE}
//               currentPage={currentPage}
//               onPageChange={setCurrentPage}
//             />
//           </>
//         )}
//       </div>
//     </>
//   );
// }

import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import classes from "./Category.module.css";
import BreadCrumb from "../../components/Breadcrumb";
import PaginationComp from "../../components/PaginationComp";
import API from "../../utils/api";
import { filterVisibleCategories } from "../../utils/categoryFilters";
import { FaBoxOpen } from "react-icons/fa";
import { Helmet } from "react-helmet";
import LoaderComp from "../../components/LoaderComp";

const CATEGORIES_PER_PAGE = 10;

export default function Category() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const res = await API.post("/categories.php", { action: "fetch" });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      const visible = filterVisibleCategories(data);
      const nonEmpty = visible.filter((cat) => Number(cat.count) > 0);
      setCategories(nonEmpty);
    } catch (err) {
      console.error("Failed to fetch categories:", err);
      setCategories([]);
    } finally {
      setLoading(false);
      setCurrentPage(1);
    }
  };

  const paginatedCategories = useMemo(() => {
    const start = (currentPage - 1) * CATEGORIES_PER_PAGE;
    return categories.slice(start, start + CATEGORIES_PER_PAGE);
  }, [categories, currentPage]);

  return (
    <>
      <Helmet>
        <title>
          Product Categories - TechMatter UK | Servers, PCs & Networking
        </title>
        <meta
          name="description"
          content="Browse all product categories at TechMatter UK. Find high-quality servers, PCs, networking equipment, and IT hardware with detailed product listings."
        />
        <link rel="canonical" href="https://techmatter.co.uk/category" />
      </Helmet>
      <BreadCrumb currentPage="Category" />

      <div className={classes.categoryWrapper}>
        {loading ? (
          <LoaderComp />
        ) : categories.length === 0 ? (
          <div className={classes.noCategories}>No categories found.</div>
        ) : (
          <>
            <div className={classes.categoryGrid}>
              {paginatedCategories.map((cat) => (
                <Link
                  to={
                    cat.category_slug
                      ? `/category/${cat.category_slug}`
                      : "/shop"
                  }
                  key={cat.id}
                  className={classes.categoryCard}
                >
                  <div className={classes.iconWrapper}>
                    <FaBoxOpen size={40} color="var(--primary-color)" />
                  </div>
                  <h3 className={classes.categoryName}>{cat.categoryName}</h3>
                  <p className={classes.categoryCount}>{cat.count} products</p>
                </Link>
              ))}
            </div>

            <PaginationComp
              total={categories.length}
              perPage={CATEGORIES_PER_PAGE}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
            />
          </>
        )}
      </div>
    </>
  );
}
